import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Invite } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Invite>>>;

const getInvitesForGroup = (id: string): ReturnType => {
    return Request.get(`/groups/${id}/invites`);
};

export default getInvitesForGroup;
